<template>
  <div
    v-if="showLoadingState < 4"
    key="loadingState"
    class="m-initial-loading"
  >
    <AtomLoadingSecondary/>
  </div>
  <div v-else>
    <a
      v-if="ventaReemplazante"
      class="m-card-primary m-card-transition m-card-record-link margin-auto"
      @click="modalViewPendingChangePlan(Object.assign(ventaReemplazante, {'changePlan': true}))"
    >
      <p class="text-color-black-65">
        {{ $t('mEditionBillingMyPaymentsPaymentMethod.paragraphPlanChangePending.text') }}
      </p>
      <p class="recod-link-call-to-action recod-link-call-to-action-billing">
        {{ $t('mEditionBillingMyPaymentsPaymentMethod.paragraphPlanChangePending.btn') }}
      </p>
    </a>

    <a
      v-else-if="suscripcionNotificada"
      class="m-card-primary m-card-transition m-card-record-link margin-auto"
      @click="modalViewPendingChangePlan({
          'suscripcion': suscripcionNotificada,
          'venta': venta.venta
          })"
    >
      <p
        v-if="suscripcionNotificada.id_plan === venta.venta.id_plan"
        class="m-card-record-info m-card-record-link"
      >
        {{ $t('mEditionBillingMyPaymentsPaymentMethod.paragraphPaymentMethodChangePending.text') }}
      </p>
      <p
        v-else
        class="m-card-record-info m-card-record-link"
      >
        {{ $t('mEditionBillingMyPaymentsPaymentMethod.paragraphPlanChangePending.text') }}
      </p>
      <p class="recod-link-call-to-action recod-link-call-to-action-billing">
        {{ $t('mEditionBillingMyPaymentsPaymentMethod.paragraphPaymentMethodChangePending.btn') }}
      </p>
    </a>

    <p v-else-if="!venta.venta.precio || !venta.venta.id_plan">
      {{ $t('mEditionBillingMyPaymentsPaymentMethod.paragraph.line1') }}
      <span class="font-weight-bold">
        {{ $t('mEditionBillingMyPaymentsPaymentMethod.paragraph.strong') }}
      </span>
    </p>

    <div
      v-else
      class="m-card-primary m-card-transition m-card-record-link margin-auto"
    >
      <p>
        {{ $t('mEditionBillingMyPaymentsPaymentMethod.paragraphElse.line1') }}
        <span class="font-weight-bold">
            {{ venta.venta.medio_pago === 'Stripe' ? 'Tarjeta de Crédito o Débito' : venta.venta.medio_pago}}
          </span>,
        <br> {{ $t('mEditionBillingMyPaymentsPaymentMethod.paragraphElse.line2') }}
      </p>
      <p
        class="recod-link-call-to-action recod-link-call-to-action-billing"
        @click="modalPaymentMethod({
          gateways: pasarelas,
          pasarela: venta.venta.medio_pago,
          plan: venta.venta.id_plan,
          producto: venta.venta.producto_venta,
          venta: venta.venta.id_venta
        })"
      >
        {{ $t('mEditionBillingMyPaymentsPaymentMethod.paragraphElse.change') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyPaymentsPaymentMethod',

  data () {
    return {
      divisa: null,
      divisas: [],
      pasarelas: [],
      productoGestion: null,
      showLoadingState: 0,
      suscripcionNotificada: null,
      venta: null,
      ventaReemplazante: null
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      this.showLoadingState = 0
      this.readVenta()
    }
  },

  created () {
    this.readVenta()
    this.readChangePlan()
    this.readSubscriptionNotificada()
  },

  methods: {
    modalPaymentMethod (params) {
      this.$modal.showModal('MoleculeEditionBillingMyPaymentsModalChangePaymentMethod', params)
    },

    modalViewPendingChangePlan (params) {
      this.$modal.showModal('MoleculeEditionBillingMyPaymentsModalPendingChangePlan', params)
    },

    readChangePlan () {
      this.$services.read('ventas', 'readChangePlan', {}, [ this.$store.getters.getAcademyData.licencia.venta ])
        .then(response => {
          if (response.status === 204) {
            this.ventaReemplazante = null
          } else {
            this.ventaReemplazante = response.data
            if (this.$route.params.subedition === this.$t('mEditionMenu.billing.myPayments.children.subscribedPlan.subedition')) {
              setTimeout(function () { this.readChangePlan() }.bind(this), 10000)
            }
          }
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readDivisas () {
      this.$services.read('divisa', 'readDivisas')
        .then(response => {
          this.divisas = response.data
          this.divisa = this.venta.venta.divisa_iso_code
            ? this.divisas.find(divisa => divisa.iso_code === this.venta.venta.divisa_iso_code)
            : null
          this.readProductoGestiones(this.venta.venta.producto_venta)
        })
        .catch(error => {
          console.log(error)
        })
    },

    readProductoGestiones (producto) {
      this.$services.read('producto', 'readProductoGestiones', {}, [producto])
        .then(response => {
          this.pasarelas = this.divisa
            ? response.data.find(p => { return p.divisa.id_divisa === this.divisa.id_divisa }).pasarelas
            : []
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readSubscriptionNotificada () {
      this.$services.read('ventas', 'readSubscriptionNotificada', {}, [ this.$store.getters.getAcademyData.licencia.venta ])
        .then(response => {
          if (response.status === 204) {
            this.suscripcionNotificada = null
          } else {
            this.suscripcionNotificada = response.data
          }
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readVenta () {
      this.$services.read('ventas', 'readVenta', {}, [ this.$store.getters.getAcademyData.licencia.venta ])
        .then(response => {
          this.venta = response.data
          this.readDivisas()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    }
  }
}
</script>
